// Card descriptions, recommendation map, and modal copy for the
// Normal Balance add-level flow. Card keys map to entries in
// `decisionTypes['Normal Balance']` (see ./data) so the lookup into
// filterItems is by-label, matching the BE/Principles/Classification
// flows.
//
// 'norm-elements' is intentionally excluded — it's the auto-created
// Level 1 and not user-selectable.

export const normalBalanceDecisionTypeCards = [
  {
    key: 'norm-default',
    title: 'Accounts',
    description: [
      { text: 'In this level, students will sort accounts to their correct normal balance (Debit, Credit).' },
    ],
  },
  {
    key: 'norm-tricky',
    title: 'Deferral & Contra Accounts',
    description: [
      { text: 'In this level, students will sort common deferral and contra accounts to their correct normal balance.' },
    ],
  },
];

// No level-specific recommendation by default. Add an entry here
// (e.g. { 2: 'norm-default' }) if a particular level should surface
// a card as recommended.
export const normalBalanceRecommendedByLevel = {};

export const normalBalanceModalCopy = {
  title: (levelNumber) => `Level ${levelNumber} | Select Decision Type`,
  subtitle: 'In each level, students sort items to their applicable normal balance category.',
  step2Title: (levelNumber) => `Level ${levelNumber} | Select Scenario & Accounts`,
  step2Subtitle: 'Select a scenario and related accounts',
  scenariosColumnHeader: 'Scenarios',
  transactionsColumnHeader: 'Transactions',
  accountsColumnHeader: 'Accounts',
  changeDecisionTypeButton: 'Change Decision Type',
  saveButton: 'Save',
  recommendedBadge: ['Recommended', 'for this Level'],
  switchScenarioWarningTitle: 'Are you sure?',
  switchScenarioWarningText: 'Selecting a transaction from a different business scenario will override your existing selections. You cannot mix transactions from different business scenarios in one level.',
};

// Card colors per the Normal Balance spec. Background + stroke are
// inlined as CSS variable overrides on the modal root. Title text and
// divider follow the BE pattern (navy text, divider matching border).
export const normalBalanceTheme = {
  '--be-card-bg': '#EBF2FF',
  '--be-card-border': '#4C8AFF',
  '--be-card-divider': '#4C8AFF',
  '--be-card-text': '#2A4169',
};
